<div mat-dialog-title class="cust-modal-title">
  <h2 class="m-0">{{ parentData.title }}</h2>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <div>
    <mat-form-field appearance="outline">
      <mat-label>Title</mat-label>
      <input
        [maxlength]="30"
        [(ngModel)]="buisnessPromotionData.postTitle"
        matInput
        #input
      />
      
      
    </mat-form-field>
  </div>
  <div>
    <mat-form-field appearance="outline">
      <mat-label>Description</mat-label>
      <textarea
        [(ngModel)]="buisnessPromotionData.description"
        matInput
      ></textarea>
      <mat-icon matSuffix class="material-icons-outlined">description</mat-icon>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field appearance="outline">
      <mat-label>Target region</mat-label>
      <input
        [(ngModel)]="buisnessPromotionData.targetCity"
        matInput
        (smLocationAutocomplete)="locationAutoComplete($event)"
      />
      <mat-icon matSuffix class="material-icons-outlined"
        >person_pin_circle</mat-icon
      >
    </mat-form-field>
  </div>
  <div>
    <mat-form-field appearance="outline">
      <mat-label>Target user</mat-label>
      <mat-select [(ngModel)]="buisnessPromotionData.targetUser">
        <mat-option [value]="1"> All Owner </mat-option>
        <mat-option [value]="2"> All Employee </mat-option>
        <mat-option [value]="3"> All Consumer </mat-option>
        <mat-option [value]="4"> All Users </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div style="display: flex; justify-content: center; align-items: center">
    <mat-spinner [diameter]="20" *ngIf="loader"></mat-spinner>
  </div>

  <mat-chip-listbox
    style="display: flex; flex-wrap: wrap; width: 400px"
    aria-label="Fish selection"
    class="mb-2"
    *ngIf="!loader"
  >
    <mat-chip
      color="primary"
      selected
      *ngFor="let asset of assetList; let i = index"
      [removable]="removable"
      (removed)="removeAsset(i)"
      
      >{{ asset?.assetName }}
      <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon></mat-chip
    >
  </mat-chip-listbox>
  <div class="upload-group mb-2">
    <label for="formFile" class="form-label">Upload media</label>
    <div class="file-input-wrap">
      <div class="custom-input-label">
        <mat-icon class="material-icons-outlined" class="mb-1" color="primary"
          >backup</mat-icon
        >
        <p>Drop your file(s) here or <span>browse</span></p>
      </div>
      <input
        class="form-control"
        id="formFile"
        accept="image/*, video/*"
        type="file"
        multiple
        (change)="onUploadImage($event)"
      />
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button
    mat-flat-button
    color="accent"
    [disabled]="
      assetList.length === 0 ||
      !buisnessPromotionData.postTitle ||
      !buisnessPromotionData.description ||
      !buisnessPromotionData.targetUser
    "
    (click)="onPost()"
  >
    {{ editMode ? "Edit" : "Save" }}
  </button>
</mat-dialog-actions>
